import React, { useState } from 'react';
import BusinessPartnerDetailsWidget from './BusinessPartnerDetailsWidget';
import { IBusinessPartnerTabProps } from '../..';
import SalesForceBusinessPartnerDrawer from '../../../business-partners-listing/salesforce-business-partners-drawer/SalesForceBusinessPartnerDrawer';

const SummaryTab: React.FC<IBusinessPartnerTabProps> = ({
  generalData,
  businessPartnerDetails,
  onSuccess,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>();
  return (
    <>
      <BusinessPartnerDetailsWidget
        data={businessPartnerDetails}
        isActive={generalData.businessPartner.isActive}
        onClick={() => setIsDrawerOpen(true)}
      />
      {isDrawerOpen && (
        <SalesForceBusinessPartnerDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onSuccess={() => onSuccess}
          businessPartnerId={generalData.businessPartner.id}
          salesForceBusinessPartnerDetailsInfo={businessPartnerDetails as any}
        />
      )}
    </>
  );
};

export default SummaryTab;
